
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { UserEditForm } from '../form/UserEditForm';

interface UserEditDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  user: any;
  onSave: (userData: any) => void;
}

export const UserEditDialog: React.FC<UserEditDialogProps> = ({
  open,
  setOpen,
  user,
  onSave
}) => {
  if (!user) return null;
  
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Modifier l'utilisateur</DialogTitle>
          <DialogDescription>
            Mettre à jour les informations de l'utilisateur
          </DialogDescription>
        </DialogHeader>
        
        <UserEditForm 
          user={user} 
          onCancel={() => setOpen(false)}
          onSave={onSave}
        />
      </DialogContent>
    </Dialog>
  );
};
